export default {
  custom_additive: {
    placeholder: 'Adicionar opção personalizada',
  },
  buttons: {
    add: 'Adicionar',
  },
};
